import { Lock, type LucideIcon } from "lucide-react";

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { Link } from "@tanstack/react-router";
import { Badge } from "../ui/badge";

export function SingleMenu({
  items,
  label,
}: {
  label: string;
  items: {
    title: string;
    url: string;
    icon: LucideIcon;
    isVisible: boolean;
    disabled: boolean;
  }[];
}) {
  return (
    <SidebarGroup aria-label={`${label}-nav-group`}>
      <SidebarGroupLabel>{label}</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => {
          if (!item.isVisible) return null;
          return (
            <SidebarMenuItem key={item.title}>
              <Link
                to={item.url}
                disabled={item.disabled}
                aria-label="basic-tour-guide"
              >
                {({ isActive }: { isActive: boolean }) => {
                  return (
                    <SidebarMenuButton
                      tooltip={item.title}
                      isActive={isActive}
                      disabled={item.disabled}
                      className="w-full"
                    >
                      <item.icon />
                      <span className="flex items-center gap-2">
                        <span>{item.title}</span>
                        {item.title === "Inbox Placement Test" && (
                          <Badge>Beta</Badge>
                        )}
                      </span>
                    </SidebarMenuButton>
                  );
                }}
              </Link>
            </SidebarMenuItem>
          );
        })}
        {/* <SidebarMenuItem>
          <SidebarMenuButton className="text-sidebar-foreground/70">
            <MoreHorizontal className="text-sidebar-foreground/70" />
            <span>More</span>
          </SidebarMenuButton>
        </SidebarMenuItem> */}
      </SidebarMenu>
    </SidebarGroup>
  );
}
